import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';

import { PermitFile, isPermitFileExcel, isPermitFilePdf, isPermitFileWord, permitFileDescription, permitFileName, safePermitFileUrl } from '../../../models/permit.model';
import { PermitFilePreviewDialogComponent } from '../../dialogs/permit-file-preview-dialog/permit-file-preview-dialog.component';

@Component({
    selector: 'app-permit-resources-step',
    templateUrl: './permit-resources-step.component.html',
    styleUrls: ['./permit-resources-step.component.scss'],
})
export class PermitResourcesStepComponent {
    @Input() files: PermitFile[] = [];

    constructor(
        private dialog: MatDialog,
        private translate: TranslateService,
    ) {}

    fileName(file: PermitFile): string {
        return permitFileName(file);
    }

    fileDescription(file: PermitFile): string {
        return permitFileDescription(file, this.translate.currentLang || 'fr');
    }

    isPdf(file: PermitFile): boolean {
        return isPermitFilePdf(file);
    }

    isWord(file: PermitFile): boolean {
        return isPermitFileWord(file);
    }

    isExcel(file: PermitFile): boolean {
        return isPermitFileExcel(file);
    }

    fileUrl(file: PermitFile): string | null {
        return safePermitFileUrl(file);
    }

    openFile(file: PermitFile): void {
        if (this.isPdf(file)) {
            this.dialog.open(PermitFilePreviewDialogComponent, {
                width: '800px',
                maxWidth: '95vw',
                height: '90vh',
                autoFocus: false,
                data: { file },
            });
            return;
        }
        const url = this.fileUrl(file);
        if (!url) return;
        window.open(url, '_blank', 'noopener,noreferrer');
    }
}
